export default __webpack_public_path__ + "static/media/responsibilities.52156756.svg";